module.exports = __webpack_public_path__ + "static/media/gd.b402c8c6.svg";